import { render, staticRenderFns } from "./TriviaGame.vue?vue&type=template&id=2216089b&scoped=true&"
import script from "./TriviaGame.vue?vue&type=script&lang=js&"
export * from "./TriviaGame.vue?vue&type=script&lang=js&"
import style0 from "./TriviaGame.vue?vue&type=style&index=0&id=2216089b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216089b",
  null
  
)

export default component.exports